import * as React from 'react'

function SvgComponent(props: any) {
    return (
        <svg
            width={93}
            height={94}
            viewBox='0 0 93 94'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M90 47.237H25.119v44.237H90V47.237z'
                stroke='#000'
                strokeWidth={5}
                strokeMiterlimit={10}
            />
            <path
                d='M33.966 26.593C33.966 13.617 44.583 3 57.56 3c12.977 0 23.594 10.617 23.594 23.593V48.27M19.22 26.593H4.475M22.17 19.22l-7.373-7.373M22.17 33.966l-7.373 7.373'
                stroke='#000'
                strokeWidth={5}
                strokeMiterlimit={10}
            />
            <path
                d='M65.817 63.605a8.937 8.937 0 00-8.995-8.995 8.937 8.937 0 00-8.995 8.995c0 3.391 1.917 6.34 4.719 7.962l-4.719 11.945h17.99l-4.719-11.945c2.802-1.474 4.719-4.423 4.719-7.962z'
                fill='#300038'
            />
            <path
                d='M50.186 63.457H31.312c-2.212-5.16-7.52-8.847-13.566-8.847C9.636 54.61 3 61.246 3 69.356S9.636 84.1 17.746 84.1c6.046 0 11.207-3.686 13.566-8.847h3.834l4.718 2.95 4.424-2.95 5.898 2.95 7.373-8.848-7.373-5.899z'
                fill='#fff'
                stroke='#000'
                strokeWidth={5}
                strokeMiterlimit={10}
            />
        </svg>
    )
}

export default SvgComponent
